export default {
  modulos: [],
  modulo: {}
}